module.exports = __webpack_public_path__ + "3692f35f78a81ca903f1c3ea5ede00e2.svg";